import { DialogTitle as MuiDialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitlePropsType } from './DialogTitle.types';

export function DialogTitle(props: DialogTitlePropsType) {
  const { onClose, fontSize, title } = props;
  return (
    <MuiDialogTitle fontSize={fontSize} display='flex' justifyContent='space-between'>
      {title}
      <IconButton onClick={onClose}>
        <CloseIcon fontSize='small' sx={{ color: (theme) => theme.palette.grey[700] }} />
      </IconButton>
    </MuiDialogTitle>
  );
}
